<script setup lang="ts">
import { IContentWrapper } from './'

interface Props {
  title: string
  desktop?: boolean
  smallText: boolean
}

defineProps<Props>()
</script>

<template>
  <i-content-wrapper class="auth" :desktop="desktop">
    <h1 class="auth__title" v-text="title" />
    <div class="auth__subtitle">
      <slot name="subtitle" />
    </div>
    <div class="auth__form"><slot /></div>
    <div v-if="smallText" class="auth__caption">
      <slot name="caption" />
    </div>
    <div class="auth__button">
      <slot name="button" />
    </div>
  </i-content-wrapper>
</template>

<style scoped lang="scss">
.auth {
  display: flex;
  flex-direction: column;
  gap: 24px;
  background-color: white;

  &__title {
    margin-top: 8px;
    color: $primary-text;
    @include h2-1;
  }

  &__subtitle {
    color: $sub-text;
    @include h5-2;
  }

  &__caption {
    color: $sub-text;
    @include h7-1;
  }

  &__button {
    width: 100%;
    &:deep(> button) {
      width: 100%;
    }
  }
}
</style>
